// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-establishments-modal .title-block{margin-bottom:1em;text-align:center}.add-establishments-modal .title-block .title{font-size:32px;margin-bottom:.5em}.add-establishments-modal .title-block .subtitle{font-size:20px;color:#8a8a8a}.add-establishments-modal .actions{display:flex;justify-content:flex-end;margin-top:1em}.add-establishments-modal .actions button{margin:.5em}.add-establishments-modal .actions .cancel-btn{background:#393939}", ""]);
// Exports
module.exports = exports;
